import React from "react";
import { BeautifullUiDesignStyle } from "./style";

import secureData from "../../images/secure_data.png";
import modernOne from "../../images/modernUI/modernOne.png";
import modernTwo from "../../images/modernUI/modernTwo.png";
import modernThree from "../../images/modernUI/modernThree.png";

const BeautifullUiDesign = () => {
  return (
    <BeautifullUiDesignStyle>
      {/* ModernUI-Section-Start */}
      <section className="row_am modern_ui_section" id="modernUI">
        {/* container start */}
        <div className="container">
          {/* row start */}
          <div className="row">
            <div className="col-lg-6">
              {/* UI content */}
              <div className="ui_text">
                <div
                  className="section_title"
                  data-aos="fade-up"
                  data-aos-duration={1500}
                  data-aos-delay={100}
                >
                  <h2>
                    <span>Participate </span>in Events
                  </h2>
                  <p>
                    Experience a visually stunning interface that combines sleek
                    design with intuitive functionality. Our app boasts a modern
                    UI that enhances your user experience, making every
                    interaction seamless and enjoyable.
                  </p>
                </div>
                <ul className="design_block">
                  <li data-aos="fade-up" data-aos-duration={1500}>
                    <h4>Participate in Events</h4>
                    <p>
                      Join exciting sports events with ease. Riva allows you
                      to find and participate in a variety of competitions.
                    </p>
                  </li>
                  <li data-aos="fade-up" data-aos-duration={1500}>
                    <h4>Premium Subscription Plans</h4>
                    <p>
                      Unlock exclusive features with our Premium subscription.
                    </p>
                  </li>
                  <li data-aos="fade-up" data-aos-duration={1500}>
                    <h4>Subscription Options:</h4>
                    <p>
                      Monthly: $30 per month
                      <br />
                      Annual: $300 per year (Save $60!) <br />
                      Upgrade now and take full advantage of all that Riva
                      has to offer!
                    </p>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-lg-6">
              {/* UI Image */}
              <div
                className="ui_images"
                data-aos="fade-in"
                data-aos-duration={1500}
              >
                <div className="left_img">
                  <img
                    className="moving_position_animatin "
                    src={modernOne}
                    alt="image"
                  />
                </div>
                {/* UI Image */}
                <div className="right_img">
                  <img
                    className="moving_position_animatin"
                    src={secureData}
                    alt="image"
                  />
                  <img
                    className="moving_position_animatin img1"
                    src={modernTwo}
                    alt="image"
                  />
                  <img
                    className="moving_position_animatin img2"
                    src={modernThree}
                    alt="image"
                  />
                </div>
              </div>
            </div>
          </div>
          {/* row end */}
        </div>
        {/* container end */}
      </section>
      {/* ModernUI-Section-end */}
    </BeautifullUiDesignStyle>
  );
};

export default BeautifullUiDesign;
